import React from 'react';

interface IntradayFilterBarProps {
  symbolFilter: string;
  onSymbolFilterChange: (value: string) => void;
  onSymbolSearch: () => void;
  selectedAction: 'all' | 'BUY' | 'SELL';
  onActionChange: (value: 'all' | 'BUY' | 'SELL') => void;
  selectedStrategy: string;
  onStrategyChange: (value: string) => void;
}

const IntradayFilterBar: React.FC<IntradayFilterBarProps> = ({
  symbolFilter,
  onSymbolFilterChange,
  onSymbolSearch,
  selectedAction,
  onActionChange,
  selectedStrategy,
  onStrategyChange,
}) => {
  return (
    <div className="bg-black/20 backdrop-blur-sm border-b border-white/10 px-4 py-3 mb-4 rounded-lg">
      <div className="flex items-center gap-3 flex-wrap">
        <div className="relative">
          <input
            type="text"
            value={symbolFilter}
            onChange={(e) => onSymbolFilterChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                onSymbolSearch();
              }
            }}
            placeholder="标的搜索..."
            className="w-32 bg-white/5 border border-white/10 rounded-lg px-3 py-1.5 text-white text-sm placeholder-white/30 focus:outline-none focus:ring-1 focus:ring-blue-500/50 focus:border-blue-500/50 transition-all"
          />
          <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none text-white/20">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
        </div>

        <select
          value={selectedAction}
          onChange={(e) => onActionChange(e.target.value as 'all' | 'BUY' | 'SELL')}
          className="px-3 py-1.5 bg-white/5 border border-white/10 rounded-lg text-white text-sm focus:outline-none focus:border-blue-500/50 focus:ring-1 focus:ring-blue-500/50 transition-all cursor-pointer hover:bg-white/10"
        >
          <option value="all" className="bg-gray-900 text-white">全部方向</option>
          <option value="BUY" className="bg-gray-900 text-green-400">买入信号</option>
          <option value="SELL" className="bg-gray-900 text-red-400">卖出信号</option>
        </select>

        <select
          value={selectedStrategy}
          onChange={(e) => onStrategyChange(e.target.value)}
          className="px-3 py-1.5 bg-white/5 border border-white/10 rounded-lg text-white text-sm focus:outline-none focus:border-blue-500/50 focus:ring-1 focus:ring-blue-500/50 transition-all cursor-pointer hover:bg-white/10"
        >
          <option value="all" className="bg-gray-900 text-white">全部策略</option>
          <option value="macd_intraday" className="bg-gray-900 text-white">MACD 盘中策略</option>
          <option value="bollinger_breakout" className="bg-gray-900 text-white">布林带突破策略</option>
          <option value="rsi_reversal" className="bg-gray-900 text-white">RSI 反转策略</option>
        </select>
        
        <div className="flex-1"></div>
        
        <button 
          onClick={onSymbolSearch}
          className="px-4 py-1.5 bg-blue-500/20 text-blue-300 border border-blue-500/30 rounded-lg text-sm hover:bg-blue-500/30 transition-all flex items-center gap-1"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          刷新
        </button>
      </div>
    </div>
  );
};

export default IntradayFilterBar;
